import {
	faChevronLeft,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Nav, Pagination } from "react-bootstrap";

export const setPageParam = (newPageIndex) => {
	let params = new URLSearchParams(window.location.search);
	if (newPageIndex === 0) {
		params.delete("page");
	} else {
		params.set("page", newPageIndex + 1);
	}
	window.history.replaceState(
		{},
		"",
		`${window.location.pathname}?${params}`
	);
};

export const PaginationRibbon = ({
	pageCount,
	pageIndex,
	nextPage = console.log,
	previousPage = console.log,
	canPreviousPage,
	canNextPage,
	gotoPage = console.log,
}) => {
	if (pageCount < 2) {
		return <div />;
	}
	const paginButtons = [
		<Pagination.Prev
			key="paginBut-prev"
			disabled={!canPreviousPage}
			onClick={() => {
				previousPage();
				setPageParam(pageIndex - 1);
			}}
		>
			<FontAwesomeIcon icon={faChevronLeft} />
		</Pagination.Prev>,
		<Pagination.Item
			key={`paginBut-0`}
			onClick={() => {
				gotoPage(0);
				setPageParam(0);
			}}
			active={pageIndex === 0}
		>
			1
		</Pagination.Item>,
	];

	let startIndex = pageIndex > 2 ? pageIndex - 2 : 1;

	if (startIndex > 1) {
		paginButtons.push(
			<Pagination.Item key={`paginBut-start`} disabled>
				...
			</Pagination.Item>
		);
	}

	for (let i = startIndex; i < pageCount - 1 && i < pageIndex + 3; i++) {
		paginButtons.push(
			<Pagination.Item
				key={`paginBut-${i}`}
				onClick={() => {
					gotoPage(i);
					setPageParam(i);
				}}
				active={pageIndex === i}
			>
				{i + 1}
			</Pagination.Item>
		);
	}

	if (pageCount > pageIndex + 4) {
		paginButtons.push(
			<Pagination.Item key={`paginBut-end`} disabled>
				...
			</Pagination.Item>
		);
	}

	if (pageCount - 1)
		paginButtons.push(
			<Pagination.Item
				key={`paginBut-${pageCount - 1}`}
				onClick={() => {
					gotoPage(pageCount - 1);
					setPageParam(pageCount - 1);
				}}
				active={pageIndex === pageCount - 1}
			>
				{pageCount}
			</Pagination.Item>
		);

	paginButtons.push(
		<Pagination.Next
			key="paginBut-next"
			disabled={!canNextPage}
			onClick={() => {
				nextPage();
				setPageParam(pageIndex + 1);
			}}
		>
			<FontAwesomeIcon icon={faChevronRight} />
		</Pagination.Next>
	);

	return (
		<Nav data-testid="test-paginationRibbon">
			<Pagination className="mb-2 mb-lg-0">{paginButtons}</Pagination>
		</Nav>
	);
};
